__turbopack_context__.v({
  "logout": "ProfileItemPopupMenu-module-scss-module__vA-wIa__logout",
  "main": "ProfileItemPopupMenu-module-scss-module__vA-wIa__main",
  "profileDropdown": "ProfileItemPopupMenu-module-scss-module__vA-wIa__profileDropdown",
  "profileOption": "ProfileItemPopupMenu-module-scss-module__vA-wIa__profileOption",
  "profileOptions": "ProfileItemPopupMenu-module-scss-module__vA-wIa__profileOptions",
});
